import HeaderA from "./HeaderA";
import FooterA from "./FooterA";
import SidebarA from "./SidebarA";
import { useState, useEffect, useContext } from "react";
import { myContext } from "../MyContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { getCookie } from "../Cookie";

const CustomerDetails = () => {
  const [formData, setFormData] = useState({});
  const context = useContext(myContext);
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState([]);
  const [rechargeDetails, setRechargeDetails] = useState("");
  const [rechargeStatusDetails, setRechargeStatusDetails] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [firstPart, setFirstPart] = useState(true);
  const cookie = getCookie();
  const { id } = useParams();
  var serial = 1;

  useEffect(() => {
    console.log(openModal);
  }, [openModal]);
  useEffect(() => {
    if (rechargeDetails) {
      document.querySelector("#DialogBasic").style.display = "block";
    }
  }, [rechargeDetails]);
  useEffect(() => {
    if (!cookie.aid) {
      navigate("/");
    }

    axios
      .get("https://api.grewbig.com/index.php/item/getCustomerDetails")
      .then((d) => {
        setUserDetails(d.data);
        console.log(d);
      })
      .catch((e) => console.log(e));
    //     axios
    //       .post("https://api.grewbig.com/index.php/payment/paymentstat", data)
    //       .then((d) => {
    //         setRechargeDetails(d.data);
    //         axios
    //           .post(
    //             "https://api.grewbig.com/index.php/payment/rechargestat",
    //             data
    //           )
    //           .then((d) => {
    //             setRechargeStatusDetails(d.data);
    //           })
    //           .catch((e) => console.log(e));
    //       })
    //       .catch((e) => console.log(e));
    //   })
    //   .catch((e) => console.log(e));
  }, []);

  return (
    <div>
      <HeaderA />
      {openModal ? (
        true ? (
          <div
            className="modal show dialogbox"
            id="DialogBasic"
            data-bs-backdrop="static"
            tabindex="-1"
            role="dialog"
            style={{ display: "none", background: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-dialog" role="document">
              <div
                className="modal-content"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "10px",
                  maxWidth: "375px",
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    fontSize: "15px",
                    marginBottom: "20px",
                  }}
                  align="center"
                >
                  Do Recharge
                  <br />
                  <table className="pplan">
                    <tr>
                      <td>Recharge No</td>
                      <td>
                        {rechargeDetails.rechargeNo
                          ? rechargeDetails.rechargeNo
                          : ""}
                      </td>
                    </tr>
                  </table>
                  <button
                    className="btn btn-md btn-primary"
                    style={{ marginTop: "8px" }}
                    onClick={(e) => {
                      e.preventDefault();
                      var data = new FormData();
                      data.append("id", rechargeDetails.transaction_id);

                      axios
                        .post(
                          "https://api.grewbig.com/index.php/item/addplanduration",
                          data
                        )
                        .then((d) => {
                          //   document.querySelector("#successp").style.display =
                          //     "block";
                          alert("Recharge Done Successfuly");

                          axios
                            .get(
                              "https://api.grewbig.com/index.php/item/getCustomerDetails"
                            )
                            .then((d) => {
                              setUserDetails(d.data);
                              console.log(d);
                              setRechargeDetails("");
                              document.querySelector(
                                "#DialogBasic"
                              ).style.display = "none";
                            })
                            .catch((e) => console.log(e));
                        })
                        .catch((e) => console.log(e));
                    }}
                  >
                    Recharge
                  </button>
                  <button
                    className="btn btn-md btn-warning"
                    style={{ marginTop: "8px", marginLeft: "15px" }}
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenModal(false);
                      document.querySelector("#DialogBasic").style.display =
                        "none";
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )
      ) : (
        ""
      )}
      <div id="appCapsule">
        <div align="center" style={{ marginTop: "15px" }}>
          <div
            class="pageTitle badge badge-md badge-primary"
            style={{ fontSize: "20px", padding: "15px" }}
            align="center"
          >
            Recharge Requests
          </div>
        </div>
        <button
          className="btn btn-md btn-warning"
          onClick={(d) => {
            d.preventDefault();
            window.location.reload();
          }}
        >
          Refresh
        </button>
        <div className="section mb-5 p-2">
          <div class="card">
            <ul class="listview flush transparent no-line image-listview detailed-list mt-1 mb-1">
              {userDetails.length
                ? userDetails.map((val, index) => {
                    return (
                      <li key={val.id}>
                        <a href="#" class="item">
                          <div class="in">
                            <div>
                              <strong>
                                Name: {val.name} | Recharge Mobile No:{" "}
                                {val.rechargeNo}
                              </strong>
                              <div class="text-small text-secondary">
                                Recharge Plan: {val.plan} | Operator:{" "}
                                {val.operator}
                              </div>
                              <div class="text-small text-secondary">
                                Transaction ID: {val.transaction_id_g} |
                                Customer Mobile: {val.mobile}
                              </div>
                              <div class="text-small text-secondary">
                                Cashback Earn: {val.cashbackearn} | Cashback
                                Use: {val.cashbackuse} | Amount Paid:{" "}
                                {val.amount}
                              </div>
                            </div>
                            <div class="text-end">
                              <button
                                className="btn btn-sm btn-success"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setOpenModal(true);
                                  setRechargeDetails({
                                    rechargeNo: val.rechargeNo,
                                    transaction_id: val.transaction_id,
                                  });
                                }}
                              >
                                Do Recharge
                              </button>
                            </div>
                          </div>
                        </a>
                      </li>
                    );
                  })
                : "No Data Found"}
            </ul>
          </div>
        </div>
      </div>

      {/* App Bottom Menu */}
      <FooterA />
      {/* * App Bottom Menu */}

      {/* App Sidebar */}
      <SidebarA />
      {/* * App Sidebar */}
    </div>
  );
};

export default CustomerDetails;
